import { jsx } from "react/jsx-runtime";
import LanguageIcon from "@mui/icons-material/Language";
import { validateTidalLicense } from "../../base/index.js";
function Language(props) {
  return /* @__PURE__ */ jsx(
    LanguageIcon,
    {
      "data-testid": "Language",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Language",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
Language.tidalIconMeta = {
  categories: "map,location,time",
  name: "Language"
};
validateTidalLicense();
export {
  Language
};
//# sourceMappingURL=Language.js.map
